export default "__VITE_ASSET__Dm6AXahN__"